import { Link } from 'react-router-dom';
import { BrandLogo } from '@/components/BrandLogo.js';

const primaryBtn: React.CSSProperties = {
  display: 'inline-block',
  padding: '12px 24px',
  borderRadius: 8,
  fontWeight: 600,
  fontSize: 13,
  background: 'var(--primary)',
  color: '#000',
  textDecoration: 'none',
};

const secondaryBtn: React.CSSProperties = {
  display: 'inline-block',
  padding: '12px 24px',
  borderRadius: 8,
  fontWeight: 600,
  fontSize: 13,
  background: 'var(--bg3)',
  color: 'var(--text)',
  border: '1px solid var(--border)',
  textDecoration: 'none',
};

/**
 * Telas de dentro do app, com dados FICTÍCIOS (empresa, pessoas e números
 * inventados). Geradas por scripts/telas-do-site — ver o README de lá para
 * refazer quando as telas mudarem.
 */
const TELAS = [
  {
    src: '/images/site/diagnostico-radar.webp',
    largura: 960,
    altura: 710,
    alt: 'Resultado do Diagnóstico 5 Forças: radar com a nota de cada força e a média geral',
    legenda: 'O radar do diagnóstico: onde a empresa está em cada uma das 5 Forças.',
  },
  {
    src: '/images/site/diagnostico-socios.webp',
    largura: 960,
    altura: 819,
    alt: 'Comparação entre dois sócios: os dois radares sobrepostos e a diferença por força',
    legenda: 'Cada sócio responde sozinho; a comparação mostra onde vocês enxergam a empresa diferente.',
  },
  {
    src: '/images/site/conselheiro-plano.webp',
    largura: 960,
    altura: 323,
    alt: 'Plano do ciclo no Conselheiro: as quatro metas com o progresso de cada uma',
    legenda: 'No Conselheiro, as 4 Metas do ciclo e o quanto já se andou em cada uma.',
  },
  {
    src: '/images/site/conselheiro-pauta.webp',
    largura: 960,
    altura: 255,
    alt: 'Pauta confirmada da manhã do conselho, com os temas propostos pela empresa e pelo conselheiro',
    legenda: 'A pauta da manhã do conselho: a empresa propõe, o conselheiro confirma.',
  },
];

export function MarketingLandingPage() {
  return (
    <div className="min-h-screen" style={{ background: 'var(--bg)', color: 'var(--text)' }}>
      <header style={{ borderBottom: '1px solid var(--border)', background: 'var(--bg2)' }}>
        <div className="mx-auto flex max-w-6xl items-center justify-between px-5 py-4">
          <BrandLogo height={32} linkTo="/" />
          <nav className="flex items-center gap-3 text-sm sm:gap-4">
            <a href="#metodo" className="hidden sm:inline" style={{ color: 'var(--text2)' }}>
              Método
            </a>
            <a href="#por-dentro" className="hidden sm:inline" style={{ color: 'var(--text2)' }}>
              Por dentro
            </a>
            <a href="#plataforma" className="hidden sm:inline" style={{ color: 'var(--text2)' }}>
              Plataforma
            </a>
            <Link to="/login" className="hidden sm:inline" style={{ color: 'var(--text2)' }}>
              Entrar
            </Link>
            <Link to="/login" style={primaryBtn}>
              Acessar a plataforma
            </Link>
          </nav>
        </div>
      </header>

      <section className="mx-auto max-w-5xl px-5 py-20 text-center md:py-28">
        <p className="mb-4 text-[13px] uppercase tracking-widest" style={{ color: 'var(--text2)' }}>
          Hack Growth Network
        </p>
        <h1
          className="mb-6 text-4xl font-semibold leading-tight md:text-5xl"
          style={{ fontFamily: 'var(--font-heading)' }}
        >
          Escola de negócios para quem quer{' '}
          <span className="destaque">crescer com método</span>
        </h1>
        <p className="mx-auto mb-10 max-w-2xl text-lg" style={{ color: 'var(--text2)' }}>
          Diagnóstico As 5 Forças do Crescimento, trilhas de aprendizado e o Conselheiro, um conselho consultivo para os
          sócios — tudo integrado ao ecossistema Hack.
        </p>
        <div className="flex flex-wrap justify-center gap-3">
          <Link to="/ferramenta" style={primaryBtn}>
            Teste o diagnóstico grátis
          </Link>
          <Link to="/login" style={secondaryBtn}>
            Já sou aluno — entrar
          </Link>
        </div>
      </section>

      <section id="metodo" style={{ borderTop: '1px solid var(--border)', background: 'var(--bg2)' }} className="py-16">
        <div className="mx-auto grid max-w-5xl gap-8 px-5 md:grid-cols-3">
          <article>
            <h2 className="destaque mb-2 inline-block text-lg font-semibold" style={{ fontFamily: 'var(--font-heading)' }}>
              Diagnóstico 5 Forças
            </h2>
            <p className="text-sm" style={{ color: 'var(--text2)' }}>
              50 perguntas, radar por força, comparação entre sócios e evolução no tempo.
            </p>
          </article>
          <article>
            <h2 className="destaque mb-2 inline-block text-lg font-semibold" style={{ fontFamily: 'var(--font-heading)' }}>
              Aprendizado
            </h2>
            <p className="text-sm" style={{ color: 'var(--text2)' }}>Trilhas, programas, aulas e certificados.</p>
          </article>
          <article>
            <h2 className="destaque mb-2 inline-block text-lg font-semibold" style={{ fontFamily: 'var(--font-heading)' }}>
              Conselheiro
            </h2>
            <p className="text-sm" style={{ color: 'var(--text2)' }}>
              Um conselheiro acompanha os sócios por 12 meses: metas, pauta mensal e decisões com prazo.
            </p>
          </article>
        </div>
      </section>

      <section id="por-dentro" className="mx-auto max-w-5xl px-5 py-16">
        <h2 className="mb-2 text-center text-2xl font-semibold" style={{ fontFamily: 'var(--font-heading)' }}>
          Por dentro da plataforma
        </h2>
        <p className="mb-10 text-center text-sm" style={{ color: 'var(--text3)' }}>
          Telas reais do app, com uma empresa e números fictícios.
        </p>
        <div className="grid gap-8 md:grid-cols-2">
          {TELAS.map((t) => (
            <figure key={t.src} className="m-0">
              <a href={t.src} target="_blank" rel="noreferrer" title="Ver maior">
                <img
                  src={t.src}
                  width={t.largura}
                  height={t.altura}
                  alt={t.alt}
                  loading="lazy"
                  decoding="async"
                  className="block h-auto w-full"
                  style={{ borderRadius: 10, border: '1px solid var(--border)', boxShadow: '0 8px 24px rgba(0,0,0,.18)' }}
                />
              </a>
              <figcaption className="mt-3 text-sm" style={{ color: 'var(--text2)' }}>
                {t.legenda}
              </figcaption>
            </figure>
          ))}
        </div>
      </section>

      <section id="plataforma" className="mx-auto max-w-3xl px-5 py-16 text-center">
        <h2 className="mb-4 text-2xl font-semibold" style={{ fontFamily: 'var(--font-heading)' }}>
          Para empresas e líderes
        </h2>
        <p className="mb-8" style={{ color: 'var(--text2)' }}>
          Planos e bonificações via HackOS / HAOps. Contrate ou peça liberação de acesso à sua equipe.
        </p>
        <Link to="/login" style={secondaryBtn}>
          Entrar na plataforma
        </Link>
      </section>

      <footer
        className="py-8 text-center text-xs"
        style={{ borderTop: '1px solid var(--border)', color: 'var(--text3)' }}
      >
        © Hack Growth Network · academy.hack.net.br
      </footer>
    </div>
  );
}
